export var AutoInstallPreset;
(function (AutoInstallPreset) {
    AutoInstallPreset[AutoInstallPreset["AutoInstall"] = 0] = "AutoInstall";
    AutoInstallPreset[AutoInstallPreset["Enable"] = 1] = "Enable";
})(AutoInstallPreset || (AutoInstallPreset = {}));
